import React from 'react';
import styled, { keyframes } from 'styled-components';
import StyledOcticon from '../StyledOcticon';
import { OctofaceIcon } from '@primer/octicons-react';
import { get, COMMON } from '../constants';
const pulseKeyframes = keyframes(["0%{opacity:0.3;}10%{opacity:1;}100%{opacity:0.3;}"]);
const Animation = styled.div.withConfig({
  displayName: "SelectMenuLoadingAnimation__Animation",
  componentId: "c5vnsj-0"
})(["padding:", " ", ";text-align:center;background-color:", ";animation-name:", ";animation-duration:2s;animation-timing-function:linear;animation-iteration-count:infinite;", ""], get('space.6'), get('space.4'), get('colors.white'), pulseKeyframes, COMMON);

const SelectMenuLoadingAnimation = props => {
  return /*#__PURE__*/React.createElement(Animation, props, /*#__PURE__*/React.createElement(StyledOcticon, {
    size: 32,
    icon: OctofaceIcon
  }));
};

SelectMenuLoadingAnimation.displayName = "SelectMenuLoadingAnimation";
SelectMenuLoadingAnimation.propTypes = { ...COMMON.propTypes
};
export default SelectMenuLoadingAnimation;